<template>
  <div class="avwrapper">
    <div class="row align-center publicacaoesSection">
      <div class="columns small-12 medium-12 large-9">
        <div class="centerContent">
          <p class="carouselTitle">
            {{ $t('UMA_LANG_SASUMA_AVISOSECOMUNICADOS')}}
          </p>
          <span class="curso_linha3 azul_site_background"></span>
        </div>
      </div>
    </div>
    <div class="row align-center publicacaoesSection">
      <div class="columns small-12 medium-12 large-9">
          <div style="position: relative;">
            <AvisosSlider :slides="avisosSections"/>
            <p class="noementa"
              v-if="numAvisos == 0">
                <img src="https://www.uma.pt/wp-content/themes/uma/images/error_icon-29.png"
                  class="icon_erro"> {{ $t("UMA_LANG_SASUMA_AVISOSECOMUNICADOS_SEMAVISOS")}}
            </p>
            <router-link v-if="numAvisos > 0" to="/avisosecomunicados" class="morelinks">
              <i class="fa fa-plus-square-o"></i>{{ $t("UMA_LANG_SASUMA_VERMAIS")}}
            </router-link>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { i18n } from '@/main.js';
import axios from "@/axios";
import AvisosSlider from "@/components/AvisosSlider.vue";

export default {
  components:{
    AvisosSlider
  },
  setup () {
    
    const numAvisos = ref(0);
    const avisosSections = ref([]);
    const lang = i18n.global.locale;

    const getLast18Avisos = () => {
      const parameters =`?limit=18&offset=0&publicado=1&idioma=${lang}&owner=${import.meta.env.VITE_APP_OWNER}&sort=docaviso_datavigor&direction=DESC`
      axios.get('/docavisos'+parameters).
        then(response => {
          const { data, total } = response.data;
          const updatedData = data.map(el => {
            const updatedDesc = el.docaviso_descricao.length > 250 ?
              el.docaviso_descricao.substring(0, 250) + " (...)" : el.docaviso_descricao;
            return {
              ...el,
              docaviso_descricao: updatedDesc
            }
          })
          numAvisos.value = total;
          var i = 0;
          while (i < total) {
            var current = updatedData.slice(i, i += 6);
            var impar = current.filter((_,i) => i%2 != 0);
            var par = current.filter((_,i) => i%2 == 0);
            var final = impar.concat(par);
            avisosSections.value.push(final);
          }
        }).
        catch(error => {
          console.log(error);
        });
    }

    getLast18Avisos()

    return {
      numAvisos,
      avisosSections
    }
  }
}
</script>

<style lang="scss" scoped>
.publicacaoesSection:last-of-type{
  padding-bottom: 85px;
}

.centerContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.carouselTitle {
  font-family: 'Montserrat Bold';
  font-size: 30px;
  margin-top: 0px;
  color: #333333;
  display: inline-block;
  margin-bottom: 5px;
  padding-top: 85px;
}

.carouselTitle {
  padding-top: 85px;
}

.curso_linha3 {
  height: 3px;
  display: block;
  width: 150px;
  margin-bottom: 85px;
}

.curso_linha3 {
  margin-bottom: 50px;
}

.morelinks {
    font-size: 15px;
    font-family: 'Montserrat Bold';
    color: white;
}

.morelinks {
    padding-left: 16px;
}

.morelinks i {
    margin-right: 10px;
    font-size: 24px;
}

.publicacaoesSection .morelinks,
.publicacaoesSection .morelinks:hover{
  color: #6eb7ec;
  position: absolute;
  left: 0;
  bottom: 0;
  z-index: 50;
  text-transform: uppercase;
  margin-top: 50px;
  display: flex;
  font-size: 15px;
  align-items: center;
}

@media (max-width: 1024px) {
  .carouselTitle {
    font-size: 23px;
    padding-top: 50px;
  }
}

@media (max-width: 767px) {

  .carouselTitle {
    padding-top: 50px;
  }

  .carouselTitle {
    font-size: 19px;
  }  

  .curso_linha3 {
    margin-bottom: 30px;
  }

  .morelinks, .morelinks:hover {
    margin-bottom: 4px;
  }

  .publicacaoesSection .morelinks,
  .publicacaoesSection .morelinks:hover{
    bottom: 30px;
  }
  
}

</style>